import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faClipboard, faChartLine, faDolly, faSlidersH, faQuestionCircle, faMailBulk } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import { Menu, Image, Typography } from "antd";
// import ReactTooltip from "react-tooltip";

function Sidebar(props) {
  const [profileInformation, setProfileInformation] = useState({ full_name: "", title: "User", image_link: "", company_name: "FirmTamer" });
  const [securityProfile, setSecurityProfile] = useState([]);
  const fullMenu = [
    {
      key: 0,
      label: (
        <Link className="sidebar-brand text-center" to="/clients">
          <p style={{ color: "white" }}>{profileInformation.company_name}</p>
        </Link>
      ),
      title: "FirmTamer Home",
      className: "text-center sidebar-company-logo-area",
      visible: "true",
      permanent: "true",
    },
    { key: 1, type: "divider", visible: "true", permanent: "true" },
    {
      key: 9,
      type: "group",
      label: "Routines",
      visible: "false",
      children: [
        {
          key: 10,
          icon: <FontAwesomeIcon icon={faHome} />,
          label: "Main",
          visible: "false",
          children: [
            { key: 11, label: <Link to="/clients">Clients</Link>, link: "/clients", visible: "false" },
            { key: 12, label: <Link to="/time-sheet">Time Sheet</Link>, link: "/time-sheet", visible: "false" },
            { key: 13, label: <Link to="/task-board">Task Board</Link>, link: "/task-board", visible: "false" },
          ],
        },
        {
          key: 100,
          icon: <FontAwesomeIcon icon={faMailBulk} />,
          label: "Outreach",
          visible: "false",
          children: [{ key: 101, label: <Link to="/email-outreach">Email Outreach</Link>, link: "/email-outreach", visible: "false" }],
        },
        {
          key: 20,
          icon: <FontAwesomeIcon icon={faClipboard} />,
          label: "Invoicing",
          visible: "false",
          children: [
            { key: 21, label: <Link to="/invoices">Invoices</Link>, link: "/invoices", visible: "false" },
            { key: 22, label: <Link to="/payments">Payments</Link>, link: "/payments", visible: "false" },
            { key: 23, label: <Link to="/export-invoices">Export Invoices</Link>, link: "/export-invoices", visible: "false" },
          ],
        },
        {
          key: 30,
          icon: <FontAwesomeIcon icon={faChartLine} />,
          label: "Reports",
          visible: "false",

          children: [
            { key: 31, label: <Link to="/reports/client-reports">Client Reports</Link>, link: "/reports/client-reports", visible: "false" },
            { key: 32, label: <Link to="/reports/time-reports">Time Reports</Link>, link: "/reports/time-reports", visible: "false" },
            { key: 33, label: <Link to="/reports/task-reports">Task Reports</Link>, link: "/reports/task-reports", visible: "false" },
            { key: 34, label: <Link to="/reports/invoice-reports">Invoice Reports</Link>, link: "/reports/invoice-reports", visible: "false" },
          ],
        },
      ],
    },
    {
      key: 40,
      type: "divider",
      visible: "true",
      permanent: "true",
    },
    {
      key: 41,
      type: "group",
      label: "Setup",
      children: [
        {
          key: 50,
          icon: <FontAwesomeIcon icon={faDolly} />,
          label: "Lists",
          visible: "false",
          children: [
            { key: 51, label: <Link to="/client-categories">Client Categories</Link>, link: "/client-categories", visible: "false" },
            { key: 52, label: <Link to="/item-categories">Item Categories</Link>, link: "/item-categories", visible: "false" },
            { key: 53, label: <Link to="/items">Items</Link>, link: "/items", visible: "false" },
            { key: 54, label: <Link to="/job-statuses">Job Statuses</Link>, link: "/job-statuses", visible: "false" },
            { key: 55, label: <Link to="/task-statuses">Task Statuses</Link>, link: "/task-statuses", visible: "false" },
            { key: 56, label: <Link to="/billing-status-categories">Billing Status Categories</Link>, link: "/billing-status-categories", visible: "false" },
            { key: 57, label: <Link to="/billing-statuses">Billing Statuses</Link>, link: "/billing-statuses", visible: "false" },
            { key: 58, label: <Link to="/adjustment-codes">Adjustment Codes</Link>, link: "/adjustment-codes", visible: "false" },
            { key: 59, label: <Link to="/billing-groups">Billing Groups</Link>, link: "/billing-groups", visible: "false" },
          ],
        },
        {
          key: 80,
          icon: <FontAwesomeIcon icon={faSlidersH} />,
          label: "Settings",
          visible: "true",
          children: [
            { key: 81, label: <Link to="/user-settings">My Profile</Link>, link: "/user-settings", visible: "true", permanent: "true" },
            { key: 82, label: <Link to="/company-settings">Company Settings</Link>, link: "/company-settings", visible: "false" },
            { key: 83, label: <Link to="/users">Users</Link>, link: "/users", visible: "false" },
            { key: 84, label: <Link to="/security-profiles">Security Profiles</Link>, link: "/security-profiles", visible: "false" },
          ],
        },
        {
          key: 90,
          icon: <FontAwesomeIcon icon={faQuestionCircle} />,
          label: "Help & Resources",
          visible: "true",

          children: [
            {
              key: 93,
              label: (
                <Link
                  to="#"
                  onClick={() => {
                    props.setWelcomeTourOpen(true);
                  }}
                >
                  Quick Start Guide
                </Link>
              ),
              visible: "true",
              permanent: "true",
            },
            {
              key: 91,
              label: (
                <Link to="https://firmtamer.com/firmtamer-video-tutorials/" target="_blank">
                  Video Tutorials
                </Link>
              ),
              link: "https://firmtamer.com/firmtamer-video-tutorials/",
              visible: "true",
              permanent: "true",
            },
            {
              key: 92,
              label: (
                <Link to="https://firmtamer.com/wp-content/uploads/2021/12/FirmTamer-Guide-12_8.pdf" target="_blank">
                  User Guide
                </Link>
              ),
              link: "https://firmtamer.com/wp-content/uploads/2021/12/FirmTamer-Guide-12_8.pdf",
              visible: "true",
              permanent: "true",
            },
          ],
        },
      ],
    },
  ];
  const [menuItems, setMenuItems] = useState([
    {
      key: 3,
      label: (
        <Link className="sidebar-brand text-center" to="/clients">
          <p style={{ color: "white" }}>{profileInformation.company_name}</p>
        </Link>
      ),
      title: "FirmTamer Home",
      className: "text-center sidebar-company-logo-area testing-a",
      visible: "true",
    },
    { key: 2, type: "divider", visible: "true" },
    {
      key: 80,
      icon: <FontAwesomeIcon icon={faSlidersH} />,
      label: "Settings",
      visible: "true",

      children: [{ key: 81, label: <Link to="/user-settings">My Profile</Link>, link: "/user-settings", visible: "true", permanent: "true" }],
    },
    {
      key: 90,
      icon: <FontAwesomeIcon icon={faQuestionCircle} />,
      label: "Help & Resources",
      visible: "true",

      children: [
        {
          key: 91,
          label: (
            <Link to="https://firmtamer.com/firmtamer-video-tutorials/" target="_blank">
              Video Tutorials
            </Link>
          ),
          link: "https://firmtamer.com/firmtamer-video-tutorials/",
          visible: "true",
          permanent: "true",
        },
        {
          key: 92,
          label: (
            <Link to="https://firmtamer.com/wp-content/uploads/2021/12/FirmTamer-Guide-12_8.pdf" target="_blank">
              User Guide
            </Link>
          ),
          link: "https://firmtamer.com/wp-content/uploads/2021/12/FirmTamer-Guide-12_8.pdf",
          visible: "true",
          permanent: "true",
        },
      ],
    },
  ]);

  // Functions
  const GetUserSecurityProfile = async () => {
    let response = await props.AxiosRequest("/api/security-profile/get");
    if (response.data.status === "success") setSecurityProfile(response.data.data);
  };
  const GetUserInfo = async () => {
    let response = await props.AxiosRequest("/api/user/get/self");
    if (response.data.status === "success") {
      setProfileInformation({
        full_name: response.data.user.first_name + " " + response.data.user.last_name || "",
        title: response.data.user.title || "",
        image_link: response.data.user.image_link,
        company_name: response.data.user.name,
      });
    }
  };
  const RefreshMenuItems = async () => {
    //This is a confusing bit of code, we are goign to take fullMenu, and set visible flags based on securityProfile.
    //Then once visible flags are set, we are going to do 3 loops, starting from the most in depth group and working out, removing visible:false items,
    //and setting parents visiblity to false if all children are removed
    let b = fullMenu
      .map((topLayer, index) => {
        if (topLayer.key === 0) {
          //special case for first item in list, the company name/profile image spot
          return {
            ...topLayer,
            label: props.collapsed ? (
              <React.Fragment key={"sider-" + index}>
                <Link className="sidebar-brand text-center" to="/clients">
                  <Image src="/assets/img/brands/reggie-edited.png" preview={false} width={40} height={40} className="img-fluid rounded-circle mb-2" alt="User Profile Image" />
                </Link>
              </React.Fragment>
            ) : (
              <React.Fragment key={"sider-" + index}>
                <Link className="sidebar-brand text-center" to="/clients">
                  <span style={{ color: "white" }}>{profileInformation.company_name === "" ? "FirmTamer" : profileInformation.company_name}</span>
                </Link>
                <div className="sidebar-user cursor-none">
                  <Image
                    src={
                      profileInformation.image_link === ""
                        ? "https://firmtamer-public-bucket.s3.amazonaws.com/dui.png"
                        : "https://firmtamer-public-bucket.s3.amazonaws.com/" + profileInformation.image_link
                    }
                    preview={false}
                    width={60}
                    height={60}
                    className="img-fluid rounded-circle mb-2 cursor-none"
                    alt="User Profile Image"
                  />
                  <br />
                  <div style={{ lineHeight: "24px" }}>
                    <Typography.Text strong>{profileInformation.full_name}</Typography.Text>
                    <br />
                    <small>{profileInformation.title}</small>
                  </div>
                </div>
              </React.Fragment>
            ),
          };
        }
        let topLayerChildren = topLayer.children
          ?.map((middleLayer, mi) => {
            let children = middleLayer.children
              ?.map((bottomLayer, bi) => {
                if (bottomLayer.permanent === "true") return bottomLayer;
                if (securityProfile.find((f) => f.url === bottomLayer.link)?.viewable === 1) return { ...bottomLayer, visible: "true" };
                return { ...bottomLayer, visible: "false" };
              })
              .filter((f) => f.visible === "true");
            return {
              ...middleLayer,
              children,
              visible: children?.length > 0 || middleLayer.permanent === "true" ? "true" : "false",
            };
          })
          .filter((f) => f.visible === "true");
        return {
          ...topLayer,
          children: topLayerChildren,
          visible: topLayerChildren?.length > 0 || topLayer.permanent === "true" ? "true" : "false",
        };
      })
      .filter((f) => f.visible === "true");

    setMenuItems(b);
  };

  useEffect(() => {
    GetUserSecurityProfile();
    GetUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    RefreshMenuItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.collapsed, profileInformation, securityProfile]);

  return (
    <>
      <Menu theme="light" mode="inline" style={{ minHeight: "100%" }} defaultSelectedKeys={["1"]} items={menuItems} />
    </>
  );
}

export default Sidebar;
